import { render, staticRenderFns } from "./tempRankingMultipleEdit.modal.vue?vue&type=template&id=654ff66b"
import script from "./tempRankingMultipleEdit.modal.vue?vue&type=script&lang=js"
export * from "./tempRankingMultipleEdit.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports